import {decorate, injectable} from '@yosmanyga/di'

class Dispatcher {
    services: Map<string, Set<unknown>>

    constructor() {
        this.services = new Map()
    }

    register(
        key: string,
        service: unknown
    ) {
        const internal = this.services.get(key)

        if (!internal) {
            this.services.set(key, new Set())

            this.register(key, service)

            return
        }

        internal.add(service)
    }

    retrieve<T>(
        key: string
    ): Array<T> {
        const internal = this.services.get(key)

        if (!internal) {
            return []
        }

        return Array.from(internal as Set<T>)
    }
}

decorate(injectable(), Dispatcher)

export {
    Dispatcher
}
